import { render } from "./AppBox.vue?vue&type=template&id=5e4920e2&scoped=true"
import script from "./AppBox.vue?vue&type=script&lang=js"
export * from "./AppBox.vue?vue&type=script&lang=js"

import "./AppBox.vue?vue&type=style&index=0&id=5e4920e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e4920e2"]])

export default __exports__